/** Delegation also covers signup links rendered from content and mobile navigation. */
export function observeSignupCtaClicks(onClick: (placement: string) => void): () => void {
  const handleClick = (event: MouseEvent) => {
    if (!(event.target instanceof Element)) return;
    if (event.type === "auxclick" && event.button !== 1) return;
    const link = event.target.closest<HTMLAnchorElement>("a[href]");
    if (!link || link.closest(".cl-signUp-root") || link.matches("[aria-disabled=true]")) return;

    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin && url.origin !== "https://www.dash0.com") return;
    if (!/^\/sign-up\/?$/.test(url.pathname)) return;

    const placement = link.closest<HTMLElement>("[data-signup-placement]")?.dataset.signupPlacement
      ?? (link.closest("nav") ? "nav" : link.closest("footer") ? "footer" : "inline");
    onClick(placement);
  };
  document.addEventListener("click", handleClick, true);
  document.addEventListener("auxclick", handleClick, true);
  return () => {
    document.removeEventListener("click", handleClick, true);
    document.removeEventListener("auxclick", handleClick, true);
  };
}
